/**
 * Profiles where the "suggest another doctor" surfaces (profile card under the no-booking notice,
 * booking-page «نوبت پر شده» modal) list same-city private-office specialists instead of an online
 * visit. Per-profile on purpose (owner request 2026-10-19, Dr. Taheri only) — every other profile
 * keeps the online-visit suggestion.
 */
export interface LocalPrivateSpecialistsConfig {
  /** Search city slug (route segment), e.g. `shahrekord`. */
  city: string;
  cityName: string;
  /** Search category slug (route segment), e.g. `imaging`. */
  groupSlug: string;
  /** Specialty shown in the heading, e.g. «رادیولوژی». */
  expertiseName: string;
  /** Hits whose `display_expertise` mentions none of these are dropped (other specialties in the group). */
  includeExpertise: string[];
  /** Hits whose `display_expertise` matches any of these are dropped (e.g. dental radiology). */
  excludeExpertise?: string[];
}

export const LOCAL_PRIVATE_SPECIALISTS: Record<string, LocalPrivateSpecialistsConfig> = {
  'دکتر-عبدالمجید-طاهری-0': {
    city: 'shahrekord',
    cityName: 'شهرکرد',
    groupSlug: 'imaging',
    expertiseName: 'رادیولوژی',
    includeExpertise: ['متخصص رادیولوژی'],
    excludeExpertise: ['دهان و فک'],
  },
};

/** Own keys only — a slug like `constructor` must not resolve to an Object.prototype member. */
export const getLocalPrivateSpecialistsConfig = (slug?: string | null): LocalPrivateSpecialistsConfig | undefined =>
  slug && Object.prototype.hasOwnProperty.call(LOCAL_PRIVATE_SPECIALISTS, slug) ? LOCAL_PRIVATE_SPECIALISTS[slug] : undefined;

export const localPrivateSpecialistsTitle = (config: LocalPrivateSpecialistsConfig) =>
  `سایر پزشکان ${config.expertiseName} ${config.cityName}`;

/** Search filter value for private-office doctors («پزشکان مطبی»). */
export const PRIVATE_OFFICE_RESULT_TYPE = 'پزشکان مطبی';
